export default {
      id: "person-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#person",
      toString: function () {
        return this.url;
      }
    }